// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseUnreachableCluster } from './ResponseUnreachableCluster';
import {
  ResponseUnreachableClusterFromJSON,
  ResponseUnreachableClusterFromJSONTyped,
  ResponseUnreachableClusterToJSON,
  ResponseUnreachableClusterToJSONTyped,
} from './ResponseUnreachableCluster';
import type { ResponseRolloutSummary } from './ResponseRolloutSummary';
import {
  ResponseRolloutSummaryFromJSON,
  ResponseRolloutSummaryFromJSONTyped,
  ResponseRolloutSummaryToJSON,
  ResponseRolloutSummaryToJSONTyped,
} from './ResponseRolloutSummary';
import type { ResponseStaleCluster } from './ResponseStaleCluster';
import {
  ResponseStaleClusterFromJSON,
  ResponseStaleClusterFromJSONTyped,
  ResponseStaleClusterToJSON,
  ResponseStaleClusterToJSONTyped,
} from './ResponseStaleCluster';

/**
 *
 * @export
 * @interface ResponseRolloutSummaryList
 */
export interface ResponseRolloutSummaryList {
  /**
   *
   * @type {Array<ResponseRolloutSummary>}
   * @memberof ResponseRolloutSummaryList
   */
  items?: Array<ResponseRolloutSummary>;
  /**
   * StaleClusters lists clusters whose watch is failing, so their entries in
   * this list are last-known state; omitted when every watch is healthy.
   * @type {Array<ResponseStaleCluster>}
   * @memberof ResponseRolloutSummaryList
   */
  staleClusters?: Array<ResponseStaleCluster>;
  /**
   * UnreachableClusters lists clusters that couldn't be reached while
   * building this list; omitted when every cluster responded.
   * @type {Array<ResponseUnreachableCluster>}
   * @memberof ResponseRolloutSummaryList
   */
  unreachableClusters?: Array<ResponseUnreachableCluster>;
}

/**
 * Check if a given object implements the ResponseRolloutSummaryList interface.
 */
export function instanceOfResponseRolloutSummaryList(
  value: object,
): value is ResponseRolloutSummaryList {
  return true;
}

export function ResponseRolloutSummaryListFromJSON(
  json: any,
): ResponseRolloutSummaryList {
  return ResponseRolloutSummaryListFromJSONTyped(json, false);
}

export function ResponseRolloutSummaryListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutSummaryList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(ResponseRolloutSummaryFromJSON),
    staleClusters:
      json['staleClusters'] == null
        ? undefined
        : (json['staleClusters'] as Array<any>).map(
            ResponseStaleClusterFromJSON,
          ),
    unreachableClusters:
      json['unreachableClusters'] == null
        ? undefined
        : (json['unreachableClusters'] as Array<any>).map(
            ResponseUnreachableClusterFromJSON,
          ),
  };
}

export function ResponseRolloutSummaryListToJSON(
  json: any,
): ResponseRolloutSummaryList {
  return ResponseRolloutSummaryListToJSONTyped(json, false);
}

export function ResponseRolloutSummaryListToJSONTyped(
  value?: ResponseRolloutSummaryList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(ResponseRolloutSummaryToJSON),
    staleClusters:
      value['staleClusters'] == null
        ? undefined
        : (value['staleClusters'] as Array<any>).map(
            ResponseStaleClusterToJSON,
          ),
    unreachableClusters:
      value['unreachableClusters'] == null
        ? undefined
        : (value['unreachableClusters'] as Array<any>).map(
            ResponseUnreachableClusterToJSON,
          ),
  };
}
